<template>
  <Toast />
  <ConfirmDialog />

  <div
    v-if="cargandoComponente && !caja && !modo_venta_rapida"
    class="flex flex-column align-items-center justify-content-center min-h-screen app-background p-4"
  >
    <div
      class="surface-card p-6 shadow-8 border-round-2xl text-center"
      style="max-width: 400px; width: 100%"
    >
      <div
        class="bg-orange-100 border-circle inline-flex align-items-center justify-content-center mb-4"
        style="width: 100px; height: 100px"
      >
        <i class="pi pi-lock text-6xl text-orange-600"></i>
      </div>
      <h2 class="text-900 font-bold text-2xl mb-2">Caja Cerrada</h2>
      <p class="text-600 mb-5 line-height-3">
        El sistema está bloqueado hasta que inicies turno.
      </p>
      <Button
        label="Abrir Caja"
        icon="pi pi-key"
        class="p-button-rounded p-button-lg w-full font-bold btn-gradiente-orange border-none"
        @click="this.$router.push({ name: 'caja' })"
      />
    </div>
  </div>

  <template v-if="caja || modo_venta_rapida">
    <div class="grid app-background pos-fullscreen-wrapper">
      <div
        class="flex-grow-1 p-1 md:p-2 lg:p-2 overflow-y-auto lg:overflow-hidden"
      >
        <div class="grid h-auto lg:h-full m-0">
          <div
            class="col-12 lg:col-7 xl:col-8 flex flex-column gap-2 h-auto lg:h-full pb-2 lg:pb-0"
          >
            <div class="glass-header shadow-1 border-round-xl px-3 pt-2 pb-2">
              <!-- TIRA VENTAS PENDIENTES SIN MESA -->
              <div
                v-if="asignar_mesa_manual && ventasPendientesMesa.length > 0"
                class="flex gap-2 overflow-x-auto mb-2 pendientes-scroll"
                style="padding-bottom: 2px"
              >
                <span
                  class="text-xs font-bold text-gray-500 white-space-nowrap flex align-items-center mr-1"
                >
                  <i class="pi pi-exclamation-circle text-orange-500 mr-1"></i>
                  Sin mesa:
                </span>
                <button
                  v-for="p in ventasPendientesMesa"
                  :key="p.id"
                  class="chip-pendiente"
                  @click="abrirAsignarMesa(p)"
                >
                  <i class="pi pi-hashtag" style="font-size: 0.65rem"></i>
                  {{ p.nro_pedido }}
                  <span class="chip-sep">·</span>
                  {{ p.cliente?.nombre || "S/N" }}
                  <span class="chip-sep">·</span>
                  <b>Bs.{{ formatCurrency(p.total) }}</b>
                </button>
              </div>

              <div class="flex gap-2 align-items-center mb-2">
                <div class="buscador-wrap flex-1">
                  <i class="pi pi-search buscador-icono"></i>
                  <InputText
                    v-model="filtroProducto"
                    placeholder="Buscar platillo o código..."
                    class="buscador-input"
                  />
                </div>
                <div v-if="!mesa" class="flex gap-1">
                  <button
                    class="btn-tipo"
                    :class="
                      !esParaLlevar && !esYango
                        ? 'btn-tipo-activo'
                        : 'btn-tipo-inactivo'
                    "
                    @click="cambiarTipoServicio('mesa')"
                  >
                    <i class="pi pi-table"></i
                    ><span class="btn-tipo-texto ml-1">MESA</span>
                  </button>
                  <button
                    class="btn-tipo"
                    :class="
                      esParaLlevar ? 'btn-tipo-llevar' : 'btn-tipo-inactivo'
                    "
                    @click="cambiarTipoServicio('para_llevar')"
                  >
                    <i class="pi pi-shopping-bag"></i
                    ><span class="btn-tipo-texto ml-1">LLEVAR</span>
                  </button>
                  <button
                    class="btn-tipo"
                    :class="esYango ? 'btn-tipo-yango' : 'btn-tipo-inactivo'"
                    @click="cambiarTipoServicio('yango')"
                  >
                    <i class="pi pi-car"></i
                    ><span class="btn-tipo-texto ml-1">YANGO</span>
                  </button>
                </div>
              </div>
              <div
                class="flex gap-2 overflow-x-auto px-1 cat-scroll"
                style="padding-bottom: 4px; border-bottom: 1.5px solid #e5e7eb"
              >
                <button
                  class="cursor-pointer border-none px-3 border-round-3xl font-bold transition-all transition-duration-200 white-space-nowrap shadow-1 cat-btn"
                  :class="
                    categoriaActiva === null
                      ? 'bg-slate-800 text-white'
                      : 'bg-white text-600 hover:bg-gray-100'
                  "
                  @click="categoriaActiva = null"
                >
                  🔥 Todas
                </button>
                <button
                  v-for="cat in categorias"
                  :key="cat.id"
                  class="cursor-pointer border-none px-3 border-round-3xl font-bold transition-all transition-duration-200 white-space-nowrap shadow-1 cat-btn"
                  :class="
                    categoriaActiva === cat.id
                      ? 'bg-slate-800 text-white'
                      : 'bg-white text-600 hover:bg-gray-100'
                  "
                  @click="categoriaActiva = cat.id"
                >
                  {{ cat.nombre }}
                </button>
              </div>
            </div>

            <div
              class="flex-grow-1 overflow-y-auto pr-1 custom-scroll area-productos"
            >
              <div
                v-if="cargandoProductos"
                class="flex flex-column align-items-center justify-content-center gap-3 h-20rem"
              >
                <span
                  style="
                    font-size: 3rem;
                    animation: spin 1.5s linear infinite;
                    display: inline-block;
                  "
                  >🍽️</span
                >
                <span
                  style="
                    font-size: 0.8rem;
                    font-weight: 600;
                    color: #94a3b8;
                    letter-spacing: 2px;
                  "
                  >CARGANDO</span
                >
              </div>

              <div v-else class="productos-grid mt-1">
                <div
                  v-for="producto in productosFiltrados"
                  :key="producto.id"
                  class="prod-card"
                  :class="{ 'prod-agotado': producto.stock_cantidad <= 0 }"
                  @click="
                    producto.stock_cantidad > 0
                      ? agregarOIncrementar(producto)
                      : null
                  "
                >
                  <span
                    v-if="
                      producto.stock_cantidad > 0 &&
                      producto.stock_cantidad <= 5
                    "
                    class="badge-stock"
                    >Quedan {{ producto.stock_cantidad }}</span
                  >
                  <span
                    v-if="producto.stock_cantidad <= 0"
                    class="badge-agotado-tag"
                    >AGOTADO</span
                  >
                  <div class="prod-img-wrap">
                    <img
                      v-if="producto.imagen"
                      :src="producto.imagen"
                      class="prod-img"
                    />
                    <div v-else class="prod-img-placeholder">
                      <i
                        class="pi pi-image"
                        style="font-size: 2.5rem; color: #d1d5db"
                      ></i>
                    </div>
                  </div>
                  <div class="prod-body">
                    <div class="prod-nombre">{{ producto.descripcion }}</div>
                    <div class="prod-footer">
                      <div class="prod-precio">
                        <span class="prod-bs">Bs.</span
                        >{{ formatCurrency(producto.precio_venta) }}
                      </div>
                      <button
                        class="btn-mas"
                        :class="
                          producto.stock_cantidad <= 0
                            ? 'btn-mas-dis'
                            : 'btn-mas-act'
                        "
                        @click.stop="
                          producto.stock_cantidad > 0
                            ? agregarOIncrementar(producto)
                            : null
                        "
                      >
                        <i
                          class="pi pi-plus"
                          style="font-size: 0.9rem; font-weight: 900"
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  v-if="
                    productosFiltrados?.length === 0 &&
                    !cargandoProductos &&
                    cargandoComponente
                  "
                  class="sin-resultados"
                >
                  <i
                    class="pi pi-search"
                    style="font-size: 2.5rem; color: #d1d5db"
                  ></i>
                  <h3 class="text-700 font-medium m-0 mt-2">
                    No encontramos ese platillo
                  </h3>
                  <p class="text-500 mt-1">Intenta buscar en otra categoría</p>
                </div>
              </div>

              <div
                v-if="totalPaginas > 1"
                class="flex justify-content-center gap-2 mt-3"
              >
                <Button
                  icon="pi pi-chevron-left"
                  class="p-button-outlined p-button-sm"
                  :disabled="currentPage === 1"
                  @click="paginaAnterior"
                />
                <span class="flex align-items-center px-3 font-bold text-900"
                  >{{ currentPage }} / {{ totalPaginas }}</span
                >
                <Button
                  icon="pi pi-chevron-right"
                  class="p-button-outlined p-button-sm"
                  :disabled="currentPage === totalPaginas"
                  @click="paginaSiguiente"
                />
              </div>
            </div>
          </div>

          <div
            class="col-12 lg:col-5 xl:col-4 h-auto mt-2 lg:mt-0 pb-4 lg:pb-0 align-self-start"
          >
            <div
              class="bg-white shadow-4 border-round-2xl h-auto flex flex-column overflow-hidden border-1 border-gray-200"
            >
              <div class="p-1 bg-gray-50 border-bottom-1 border-gray-200">
                <div
                  class="flex justify-content-between align-items-center mb-1"
                >
                  <Button
                    icon="pi pi-arrow-left"
                    class="p-button-text p-button-secondary p-0 hover:bg-gray-200"
                    style="width: 3rem; height: 3rem"
                    @click="
                      $router.replace({ name: 'restaurante_plano_mesas' })
                    "
                    v-tooltip.bottom="'Volver'"
                  >
                    <i class="pi pi-arrow-left" style="font-size: 2rem"></i>
                  </Button>
                  <div class="flex flex-column align-items-center gap-1">
                    <span class="font-bold text-lg text-900">
                      <span v-if="esYango"
                        ><i class="pi pi-car"></i> YANGO
                        {{ pedido ? "#" + pedido.nro_pedido : "- NUEVO" }}</span
                      >
                      <span v-else-if="esParaLlevar"
                        ><i class="pi pi-shopping-bag"></i> PARA LLEVAR
                        {{ pedido ? "#" + pedido.nro_pedido : "- NUEVO" }}</span
                      >
                      <span v-else-if="mesaEfectiva"
                        ><i class="pi pi-table"></i> MESA
                        {{ mesaEfectiva.numero }}
                        {{
                          !cargandoComponente
                            ? "..."
                            : pedido
                            ? pedido.nro_pedido
                              ? "- #" + pedido.nro_pedido
                              : "- NUEVO"
                            : "- NUEVO"
                        }}</span
                      >
                      <span v-else
                        ><i class="pi pi-table"></i> MESA
                        {{
                          !cargandoComponente
                            ? "..."
                            : pedido
                            ? pedido.nro_pedido
                              ? "- #" + pedido.nro_pedido
                              : "- NUEVO"
                            : "- NUEVO"
                        }}</span
                      >
                    </span>
                    <span
                      v-if="pedido && pedido.estado > 1 && !omitir_cocina"
                      :class="['badge-estado-pedido-inline', estadoPedidoClass]"
                      >{{ estadoPedidoTexto }}</span
                    >
                  </div>
                  <Button
                    v-if="pedido && pedido.estado < 4"
                    icon="pi pi-trash"
                    class="p-button-text p-button-danger p-0 hover:bg-red-50"
                    style="width: 3rem; height: 3rem"
                    @click="confirmarCancelarPedido"
                    v-tooltip.bottom="'Anular'"
                  >
                    <i class="pi pi-trash" style="font-size: 1.8rem"></i>
                  </Button>
                </div>
                <div
                  class="p-inputgroup shadow-none border-1 border-gray-300 border-round-lg overflow-hidden h-2rem"
                >
                  <AutoComplete
                    v-model="clienteSelect"
                    :suggestions="clientes"
                    @complete="buscarCliente($event)"
                    placeholder="Buscar Cliente..."
                    field="nombre"
                    class="w-full border-none shadow-none h-full"
                    inputClass="border-none shadow-none text-900 font-medium text-sm p-1"
                    @item-select="onClienteSelect"
                  >
                    <template #item="{ item }">
                      <div class="flex flex-column">
                        <span class="font-bold text-gray-800 text-base">{{
                          item.nombre
                        }}</span>
                      </div>
                    </template>
                  </AutoComplete>
                  <Button
                    icon="pi pi-user-plus"
                    class="p-button-text text-blue-600 py-0 px-2"
                    @click="abrirModalNuevoCliente"
                  />
                </div>
              </div>

              <div class="carrito-wrap">
                <div class="cr-header">
                  <span class="cr-h-nombre">PRODUCTO</span>
                  <span class="cr-h-cant">CANT.</span>
                  <span class="cr-h-total">TOTAL</span>
                </div>
                <div class="carrito-lista custom-scroll">
                  <div
                    v-if="!items || items.length === 0"
                    class="carrito-vacio"
                  >
                    <i
                      class="pi pi-shopping-bag"
                      style="font-size: 2.2rem; opacity: 0.2"
                    ></i>
                    <span>Sin productos</span>
                  </div>
                  <div v-for="data in items" :key="data.id" class="carrito-row">
                    <div class="cr-nombre-bloque">
                      <span class="cr-nombre">{{
                        data.producto?.descripcion
                      }}</span>
                      <span v-if="data.nota_cocina" class="cr-nota">
                        <i class="pi pi-comment" style="font-size: 0.6rem"></i>
                        {{ data.nota_cocina }}
                      </span>
                    </div>
                    <div class="cr-cantidad">
                      <button
                        class="cr-btn-qty cr-btn-minus"
                        @click="
                          data.cantidad > 1
                            ? cambiarCantidad(data, -1)
                            : confirmarEliminarItem(data)
                        "
                      >
                        <i class="pi pi-minus" style="font-size: 0.65rem"></i>
                      </button>
                      <span class="cr-qty-num">{{ data.cantidad }}</span>
                      <button
                        class="cr-btn-qty cr-btn-plus"
                        @click="cambiarCantidad(data, 1)"
                      >
                        <i class="pi pi-plus" style="font-size: 0.65rem"></i>
                      </button>
                    </div>
                    <div class="cr-total-bloque">
                      <span class="cr-total">{{
                        formatCurrency(calcularSubtotal(data))
                      }}</span>
                      <button
                        class="cr-btn-nota"
                        :class="data.nota_cocina ? 'cr-btn-nota-activa' : ''"
                        @click="abrirModalNotaItem(data)"
                      >
                        <i
                          class="pi"
                          :class="data.nota_cocina ? 'pi-pencil' : 'pi-comment'"
                          style="font-size: 0.65rem"
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="p-1 surface-card border-top-1 border-gray-200 shadow-top-large z-2 flex-none"
              >
                <div class="mb-1 mt-0">
                  <div
                    class="flex justify-content-between align-items-center px-1 mb-0"
                  >
                    <span class="text-xs text-gray-600 font-medium"
                      >NOTA COCINA:</span
                    >
                    <div>
                      <span
                        v-if="guardandoNotaGeneral"
                        class="text-xs text-orange-500"
                        ><i class="pi pi-spin pi-spinner"></i>
                        Guardando...</span
                      >
                      <span
                        v-else-if="notaGeneralGuardada"
                        class="text-xs text-green-600"
                        ><i class="pi pi-check"></i> Guardado</span
                      >
                    </div>
                  </div>
                  <InputText
                    v-model="observaciones"
                    placeholder="Observaciones..."
                    class="w-full p-inputtext-sm border-round-lg bg-gray-50 border-1 border-gray-300 text-900 py-1 text-sm"
                  />
                </div>

                <div
                  class="flex justify-content-between align-items-center mb-0 pt-1 border-top-1 border-dashed border-gray-300 mt-1"
                >
                  <span class="total-label">TOTAL</span>
                  <span class="total-monto"
                    >Bs. {{ formatCurrency(totalConDescuento) }}</span
                  >
                </div>

                <div class="flex gap-2 mb-1">
                  <div
                    class="flex-1 flex align-items-center p-1 border-round-lg cursor-pointer border-1 bg-gray-50 hover:bg-white"
                    :class="
                      pagoQR ? 'border-blue-400 bg-blue-50' : 'border-gray-300'
                    "
                    :style="aCredito ? 'opacity:0.5;pointer-events:none' : ''"
                    @click="togglePagoQR"
                  >
                    <div
                      style="
                        width: 16px;
                        height: 16px;
                        border-radius: 4px;
                        border: 2px solid #94a3b8;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                      :style="
                        pagoQR ? 'background:#1e293b;border-color:#1e293b' : ''
                      "
                    >
                      <i
                        v-if="pagoQR"
                        class="pi pi-check"
                        style="color: white; font-size: 9px; font-weight: 900"
                      ></i>
                    </div>
                    <span class="ml-2 text-xs font-bold text-gray-700 mb-0"
                      >PAGO QR</span
                    >
                  </div>
                  <div
                    v-if="'Venta Facturar' in auth.user.permissions"
                    class="flex-1 flex align-items-center p-1 border-round-lg cursor-pointer border-1 bg-gray-50 hover:bg-white"
                    :class="
                      facturar
                        ? 'border-blue-400 bg-blue-50'
                        : 'border-gray-300'
                    "
                    @click="toggleFacturar"
                  >
                    <div
                      style="
                        width: 16px;
                        height: 16px;
                        border-radius: 4px;
                        border: 2px solid #94a3b8;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                      :style="
                        facturar
                          ? 'background:#1e293b;border-color:#1e293b'
                          : ''
                      "
                    >
                      <i
                        v-if="facturar"
                        class="pi pi-check"
                        style="color: white; font-size: 9px; font-weight: 900"
                      ></i>
                    </div>
                    <span class="ml-2 text-xs font-bold text-gray-700 mb-0"
                      >FACTURA</span
                    >
                  </div>
                </div>

                <div class="grid formgrid p-fluid mb-1 mt-2">
                  <div :class="pagoQR ? 'col-6' : 'col-12'" class="py-0">
                    <div class="p-inputgroup h-2rem">
                      <span
                        class="p-inputgroup-addon bg-gray-50 border-none text-gray-500 text-xs p-1"
                        >Efectivo</span
                      >
                      <InputNumber
                        v-model="efectivo"
                        mode="decimal"
                        :minFractionDigits="2"
                        class="p-inputtext-sm"
                        inputClass="font-bold text-right py-1 text-sm"
                        :disabled="aCredito"
                      />
                    </div>
                  </div>
                  <div v-if="pagoQR" class="col-6 py-0">
                    <div class="p-inputgroup h-2rem">
                      <span
                        class="p-inputgroup-addon bg-gray-50 border-none text-gray-500 text-xs p-1"
                        >QR</span
                      >
                      <InputNumber
                        v-model="montoQR"
                        mode="decimal"
                        :minFractionDigits="2"
                        class="p-inputtext-sm"
                        inputClass="font-bold text-right py-1 text-sm"
                        :disabled="aCredito"
                      />
                    </div>
                  </div>
                  <div v-if="qr_url && pagoQR" class="col-12 py-1">
                    <div
                      class="p-2 bg-blue-50 border-round-lg border-1 border-blue-200 text-center"
                    >
                      <p class="text-xs font-bold text-blue-700 mb-1 mt-0">
                        Escanea para pagar:
                      </p>
                      <Image
                        :src="qr_url"
                        width="180"
                        preview
                        class="border-round"
                      />
                    </div>
                  </div>
                  <div class="col-12 py-1" v-if="cambio > 0 && !aCredito">
                    <div
                      class="w-full px-2 py-1 bg-green-50 text-green-700 font-bold border-round text-right border-1 border-green-200 text-sm flex align-items-center justify-content-between"
                    >
                      <small class="text-green-500 font-normal">Cambio:</small>
                      <span>{{ formatCurrency(cambio) }}</span>
                    </div>
                  </div>
                  <template v-if="facturar">
                    <div class="col-6 mt-1 py-0">
                      <InputText
                        v-model="nit"
                        placeholder="NIT/CI"
                        class="p-inputtext-sm py-1 text-sm"
                      />
                    </div>
                    <div class="col-6 mt-1 py-0">
                      <InputText
                        v-model="razon_social"
                        placeholder="Razón Social"
                        class="p-inputtext-sm py-1 text-sm"
                      />
                    </div>
                  </template>
                </div>

                <Button
                  label="COBRAR"
                  icon="pi pi-check-circle"
                  class="w-full p-button border-none font-bold btn-gradiente-orange py-2 mt-2 mb-2"
                  :loading="guardando"
                  :disabled="items.length === 0"
                  @click="cobrarPedido"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- OVERLAY de carga -->
    <div
      v-if="!cargandoComponente"
      class="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center"
      style="z-index: 9999; pointer-events: none"
    >
      <div
        class="flex flex-column align-items-center gap-2 border-round-2xl px-5 py-4"
        style="
          background: rgba(255, 255, 255, 0.97);
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.13);
          border: 1px solid #e5e7eb;
          pointer-events: all;
        "
      >
        <span
          style="
            font-size: 2.2rem;
            animation: spin 1.5s linear infinite;
            display: inline-block;
          "
          >🍽️</span
        >
        <span
          style="
            font-size: 0.72rem;
            font-weight: 700;
            color: #94a3b8;
            letter-spacing: 3px;
          "
          >CARGANDO</span
        >
        <div class="flex gap-2 align-items-center">
          <span
            class="loading-dot border-circle"
            style="
              width: 5px;
              height: 5px;
              display: inline-block;
              background: #94a3b8;
              animation-delay: 0s;
            "
          ></span>
          <span
            class="loading-dot border-circle"
            style="
              width: 5px;
              height: 5px;
              display: inline-block;
              background: #94a3b8;
              animation-delay: 0.3s;
            "
          ></span>
          <span
            class="loading-dot border-circle"
            style="
              width: 5px;
              height: 5px;
              display: inline-block;
              background: #94a3b8;
              animation-delay: 0.6s;
            "
          ></span>
        </div>
      </div>
    </div>

    <!-- Modal nota item -->
    <Dialog
      v-model:visible="notaItemModal"
      :style="{ width: '450px' }"
      header="Nota para Cocina"
      :modal="true"
      class="p-fluid"
    >
      <div v-if="itemEditandoNota" class="mb-3">
        <div class="font-bold text-lg text-gray-800 mb-2">
          {{ itemEditandoNota.producto?.descripcion }}
        </div>
        <small class="text-gray-500"
          >Instrucciones específicas para este producto</small
        >
      </div>
      <div class="field">
        <strong>NOTA:</strong>
        <Textarea
          v-model="notaItemTemporal"
          rows="4"
          placeholder="Ej: Sin cebolla, bien cocido, extra queso..."
          class="w-full"
          autoResize
        />
      </div>
      <template #footer>
        <Button
          label="CANCELAR"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="cerrarModalNotaItem"
        />
        <Button
          label="GUARDAR"
          icon="pi pi-check"
          class="p-button-info"
          @click="guardarNotaItemModal"
        />
      </template>
    </Dialog>

    <!-- Modal confirmar cobro -->
    <Dialog
      v-model:visible="modalConfirmarCobro"
      :style="{ width: '460px' }"
      header="Confirmar Cobro"
      :modal="true"
      class="p-fluid modal-cobro-compacto"
    >
      <div class="confirmacion-cobro-compacta">
        <div
          class="mb-3 border-round-xl overflow-hidden"
          style="background: #1e293b"
        >
          <div
            class="flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <div>
              <div class="text-white font-bold" style="font-size: 1.1rem">
                <span v-if="esYango">Yango #{{ pedido?.nro_pedido }}</span>
                <span v-else-if="esParaLlevar"
                  >Para Llevar #{{ pedido?.nro_pedido }}</span
                >
                <span v-else-if="mesaEfectiva"
                  >Mesa {{ mesaEfectiva.numero
                  }}{{
                    pedido?.nro_pedido ? "  ·  #" + pedido.nro_pedido : ""
                  }}</span
                >
                <span v-else
                  >Pedido{{
                    pedido?.nro_pedido ? "  #" + pedido.nro_pedido : ""
                  }}</span
                >
              </div>
              <div style="color: #94a3b8; font-size: 0.82rem; margin-top: 2px">
                {{ clienteSelect?.nombre || "S/N" }}
              </div>
            </div>
            <div class="text-right">
              <div
                style="
                  color: #64748b;
                  font-size: 0.7rem;
                  font-weight: 700;
                  letter-spacing: 1px;
                  text-transform: uppercase;
                "
              >
                Total
              </div>
              <div
                class="text-white font-black"
                style="font-size: 1.9rem; line-height: 1.1"
              >
                Bs. {{ formatCurrency(totalConDescuento) }}
              </div>
            </div>
          </div>
          <div v-if="!aCredito" class="flex gap-2 px-3 pb-3 mt-1">
            <div
              class="flex-1 text-center border-round-lg py-2"
              style="background: rgba(255, 255, 255, 0.07)"
            >
              <div
                style="
                  color: #64748b;
                  font-size: 0.68rem;
                  font-weight: 600;
                  letter-spacing: 1px;
                  text-transform: uppercase;
                "
              >
                Efectivo
              </div>
              <div
                class="text-white font-bold"
                style="font-size: 1.1rem; margin-top: 2px"
              >
                {{ formatCurrency(efectivo) }}
              </div>
            </div>
            <div
              v-if="pagoQR"
              class="flex-1 text-center border-round-lg py-2"
              style="background: rgba(255, 255, 255, 0.07)"
            >
              <div
                style="
                  color: #64748b;
                  font-size: 0.68rem;
                  font-weight: 600;
                  letter-spacing: 1px;
                  text-transform: uppercase;
                "
              >
                QR
              </div>
              <div
                class="text-white font-bold"
                style="font-size: 1.1rem; margin-top: 2px"
              >
                {{ formatCurrency(montoQR) }}
              </div>
            </div>
            <div
              v-if="cambio > 0"
              class="flex-1 text-center border-round-lg py-2"
              style="
                background: rgba(22, 163, 74, 0.18);
                border: 1px solid rgba(22, 163, 74, 0.3);
              "
            >
              <div
                style="
                  color: #4ade80;
                  font-size: 0.68rem;
                  font-weight: 600;
                  letter-spacing: 1px;
                  text-transform: uppercase;
                "
              >
                Cambio
              </div>
              <div
                style="
                  color: #4ade80;
                  font-size: 1.1rem;
                  font-weight: 900;
                  margin-top: 2px;
                "
              >
                {{ formatCurrency(cambio) }}
              </div>
            </div>
          </div>
          <div v-if="aCredito" class="px-3 pb-3 mt-1">
            <div
              class="border-round-lg py-2 px-3 mb-2"
              style="
                background: rgba(234, 88, 12, 0.15);
                border: 1px solid rgba(234, 88, 12, 0.25);
              "
            >
              <span style="color: #fb923c; font-size: 1rem; font-weight: 700"
                ><i class="pi pi-car mr-1"></i> Yango — Pago a crédito
                (pendiente)</span
              >
            </div>
            <div
              class="border-round-lg p-2"
              style="background: rgba(255, 255, 255, 0.08)"
            >
              <strong
                style="
                  color: #fbbf24;
                  font-size: 1rem;
                  font-weight: 700;
                  display: block;
                  margin-bottom: 4px;
                "
              >
                <i class="pi pi-hashtag mr-1"></i>N° ORDEN YANGO
                <span style="color: #f87171">*</span>
              </strong>
              <InputText
                v-model="nroOrdenYango"
                placeholder="Ej: 12345"
                class="w-full p-inputtext-sm"
                :class="!nroOrdenYango ? 'p-invalid' : ''"
                style="
                  background: rgba(255, 255, 255, 0.12);
                  border-color: rgba(255, 255, 255, 0.2);
                  color: white;
                "
              />
              <small
                v-if="!nroOrdenYango"
                style="color: #fca5a5; font-size: 0.9rem"
                >Obligatorio para proceder</small
              >
            </div>
          </div>
        </div>

        <div class="border-1 surface-border border-round mb-3 overflow-hidden">
          <div
            class="bg-gray-50 p-2 text-xs font-bold text-700 border-bottom-1 surface-border"
          >
            DETALLE DE CONSUMO
          </div>
          <div class="overflow-y-auto" style="max-height: 240px">
            <table class="w-full text-sm">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  class="border-bottom-1 surface-border"
                >
                  <td class="p-2" style="width: 30px">
                    <span
                      class="bg-bluegray-100 text-bluegray-800 font-bold px-2 py-1 border-round-md text-xs"
                      >{{ item.cantidad }}</span
                    >
                  </td>
                  <td class="p-2">
                    <div class="font-medium text-900">
                      {{ item.producto?.descripcion }}
                    </div>
                    <div
                      v-if="item.nota_cocina"
                      class="text-xs text-orange-600 mt-1"
                    >
                      <i class="pi pi-comment mr-1"></i>{{ item.nota_cocina }}
                    </div>
                  </td>
                  <td
                    class="p-2 text-right font-bold text-700"
                    style="width: 90px"
                  >
                    {{ formatCurrency(calcularSubtotal(item)) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          v-if="descuento > 0"
          class="mb-2 px-3 py-2 bg-pink-50 text-pink-700 text-sm border-round flex justify-content-between"
        >
          <span class="font-bold"
            ><i class="pi pi-tag mr-2"></i>Descuento:</span
          >
          <span class="font-bold">- {{ formatCurrency(descuento) }}</span>
        </div>

        <div v-if="imprimir_comanda" class="flex gap-2 mb-2">
          <Button
            :label="imprimiendoComanda ? 'Imprimiendo...' : 'Imprimir Comanda'"
            :icon="
              imprimiendoComanda ? 'pi pi-spin pi-spinner' : 'pi pi-file-edit'
            "
            class="flex-1 p-button-warning font-bold"
            :disabled="imprimiendoComanda || !pedido?.id"
            :loading="imprimiendoComanda"
            @click="pedido?.id ? imprimirComanda(pedido.id) : null"
          />
          <Button
            v-if="comanda_impresora_separada"
            label="Comanda Parrilla"
            icon="pi pi-bolt"
            class="flex-1 p-button-help font-bold"
            :disabled="imprimiendoComanda || !pedido?.id"
            @click="pedido?.id ? imprimirComanda(pedido.id) : null"
          />
        </div>

        <div
          v-if="facturar"
          class="text-xs text-600 bg-gray-50 p-2 border-round border-1 border-dashed surface-border flex align-items-center gap-2 mb-2"
        >
          <i class="pi pi-file"></i>
          <span
            >NIT: <strong>{{ nit }}</strong></span
          >
          |
          <span
            >Razón: <strong>{{ razon_social }}</strong></span
          >
        </div>

        <div v-if="!esParaLlevar && !esYango && !mesa" class="mt-2">
          <div
            class="flex align-items-center gap-2 p-2 bg-blue-50 border-round border-1 border-blue-200"
          >
            <i class="pi pi-table text-blue-600 flex-shrink-0"></i>
            <span class="text-xs font-bold text-blue-700 white-space-nowrap"
              >Mesa (opcional):</span
            >
            <Dropdown
              v-model="mesaSeleccionadaId"
              :options="[
                { id: null, label: 'Sin mesa' },
                ...mesasDisponibles.map((m) => ({
                  id: m.id,
                  label: `Mesa ${m.numero} — ${m.zona}`,
                })),
              ]"
              optionLabel="label"
              optionValue="id"
              placeholder="Sin mesa"
              filter
              filterPlaceholder="Buscar mesa..."
              class="flex-1 p-inputtext-sm"
              style="min-width: 0"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <div class="flex gap-2 pt-1 align-items-center">
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            class="p-button-danger"
            @click="modalConfirmarCobro = false"
            :disabled="guardando || guardandoLiberar"
          />
          <div class="flex gap-2 ml-auto">
            <Button
              v-if="!esParaLlevar && !esYango && mesa"
              :label="omitir_cocina ? 'SOLO COBRAR' : 'COBRAR'"
              icon="pi pi-check"
              class="p-button-secondary font-bold"
              :disabled="guardandoLiberar"
              :loading="guardando"
              @click="procesarCobro(false)"
            />
            <Button
              v-if="!esParaLlevar && !esYango && mesa"
              label="COBRAR Y LIBERAR"
              icon="pi pi-check-circle"
              class="p-button-success font-bold"
              :disabled="guardando"
              :loading="guardandoLiberar"
              @click="procesarCobro(true)"
            />
            <Button
              v-if="esParaLlevar || esYango || !mesa"
              label="COBRAR"
              icon="pi pi-check-circle"
              class="p-button-info font-bold"
              :loading="guardando"
              @click="procesarCobro(true)"
            />
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Modal asignar mesa a venta pendiente -->
    <Dialog
      v-model:visible="modalAsignarMesa"
      :style="{ width: '420px' }"
      header="Asignar Mesa"
      :modal="true"
      class="p-fluid"
    >
      <div v-if="pedidoPendienteSel">
        <div
          class="flex justify-content-between align-items-center mb-3 p-3 border-round-xl"
          style="background: #1e293b"
        >
          <div>
            <div class="text-white font-bold">
              Pedido #{{ pedidoPendienteSel.nro_pedido }}
            </div>
            <div style="color: #94a3b8; font-size: 0.82rem">
              {{ pedidoPendienteSel.cliente?.nombre || "S/N" }}
            </div>
          </div>
          <div class="text-white font-black" style="font-size: 1.6rem">
            Bs. {{ formatCurrency(pedidoPendienteSel.total) }}
          </div>
        </div>
        <div class="border-1 surface-border border-round mb-3 overflow-hidden">
          <div
            class="bg-gray-50 p-2 text-xs font-bold text-700 border-bottom-1 surface-border"
          >
            CONSUMO
          </div>
          <div class="overflow-y-auto" style="max-height: 150px">
            <table class="w-full text-sm">
              <tbody>
                <tr
                  v-for="item in pedidoPendienteSel.items"
                  :key="item.id"
                  class="border-bottom-1 surface-border"
                >
                  <td class="p-2" style="width: 30px">
                    <span
                      class="bg-bluegray-100 text-bluegray-800 font-bold px-2 py-1 border-round-md text-xs"
                      >{{ item.cantidad }}</span
                    >
                  </td>
                  <td class="p-2 font-medium text-900">
                    {{ item.producto?.descripcion }}
                  </td>
                  <td
                    class="p-2 text-right font-bold text-700"
                    style="width: 80px"
                  >
                    {{ formatCurrency(item.cantidad * item.precio_unitario) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="flex align-items-center gap-2 p-2 bg-blue-50 border-round border-1 border-blue-200"
        >
          <i class="pi pi-table text-blue-600 flex-shrink-0"></i>
          <span class="text-xs font-bold text-blue-700 white-space-nowrap"
            >Mesa:</span
          >
          <Dropdown
            v-model="mesaParaAsignar"
            :options="
              mesasDisponibles.map((m) => ({
                id: m.id,
                label: `Mesa ${m.numero} — ${m.zona}`,
              }))
            "
            optionLabel="label"
            optionValue="id"
            placeholder="Seleccionar mesa..."
            filter
            filterPlaceholder="Buscar..."
            class="flex-1 p-inputtext-sm"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="CANCELAR"
          icon="pi pi-times"
          class="p-button-text p-button-secondary p-button-sm"
          @click="modalAsignarMesa = false"
        />
        <Button
          label="ASIGNAR MESA"
          icon="pi pi-check"
          class="p-button-info p-button-sm font-bold"
          :disabled="!mesaParaAsignar"
          :loading="asignandoMesa"
          @click="confirmarAsignarMesa"
        />
      </template>
    </Dialog>

    <ClienteCreate
      v-if="clienteModal"
      :show="clienteModal"
      :cliente="cliente"
      @closeModal="cerrarModalCliente"
      @actualizarListado="buscarYAsignarCliente"
    />
  </template>
</template>

<script>
import RestauranteService from "@/service/RestauranteService";
import ProductService from "@/service/ProductService";
import MetodoPagoService from "@/service/MetodoPagoService";
import CajaService from "@/service/CajaService";
import ClienteService from "@/service/ClienteService";
import ClienteCreate from "@/module/clientes/ClienteCreate.vue";
import { useAuth } from "@/stores";
import VentaService from "@/service/VentaService";

export default {
  components: { ClienteCreate },
  data() {
    return {
      cargandoComponente: false,
      cargandoItems: false,
      cargandoProductos: false,
      guardando: false,
      cargandoClientes: false,
      mesa: null,
      pedido: null,
      items: [],
      caja: null,
      clienteSelect: null,
      clientes: [],
      clienteModal: false,
      cliente: { estado: { label: "Activo", value: 1 } },
      categorias: [],
      productos: [],
      categoriaActiva: null,
      filtroProducto: "",
      currentPage: 1,
      lastPage: 1,
      loadingMore: false,
      hasMore: true,
      productosPorPagina: 10,
      metodo_pagos: [],
      metodo_pago_id: 1,
      efectivo: 0,
      observaciones: "",
      facturar: false,
      nit: "0",
      razon_social: "S/N",
      totalPedido: 0,
      descuento: 0,
      esParaLlevar: false,
      esYango: false,
      guardandoNotaGeneral: false,
      notaGeneralGuardada: false,
      timeoutNotaGeneral: null,
      notaItemModal: false,
      itemEditandoNota: null,
      notaItemTemporal: "",
      imprimiendo: false,
      omitir_cocina: false,
      pagoQR: false,
      montoQR: 0,
      qr_url: null,
      aCredito: false,
      modalConfirmarCobro: false,
      liberarMesaAutomatico: false,
      guardandoLiberar: false,
      ultimaVentaId: null,
      imprimir_directo: false,
      imprimiendoDirecto: false,
      imprimiendoComanda: false,
      printerName: "",
      todosLosProductos: [],
      imprimir_comanda: false,
      comanda_impresora_separada: false,
      printerCocina: null,
      modo_venta_rapida: false,
      asignar_mesa_manual: false,
      mesaSeleccionadaId: null,
      mesasDisponibles: [],
      nroOrdenYango: "",
      sucursal_id: null,
      clienteDefecto: null,
      ventasPendientesMesa: [],
      modalAsignarMesa: false,
      pedidoPendienteSel: null,
      asignandoMesa: false,
      mesaParaAsignar: null,
      auth: null,
    };
  },
  created() {
    this.restauranteService = new RestauranteService();
    this.productService = new ProductService();
    this.metodoPagoService = new MetodoPagoService();
    this.cajaService = new CajaService();
    this.clienteService = new ClienteService();
    this.auth = useAuth();
    this.ventaService = new VentaService();
  },
  async mounted() {
    const tipoServicio = this.$route.meta?.tipo_servicio;
    const tieneMesaParam = !!this.$route.params.mesa_id;
    const tienePedidoParam = !!this.$route.params.pedido_id;
    if (tipoServicio === "yango") {
      this.esYango = true;
    } else if (tipoServicio === "para_llevar") {
      this.esParaLlevar = true;
    } else if (!tieneMesaParam && !tienePedidoParam) {
      this.esParaLlevar = false;
      this.esYango = false;
    }
    await this.inicializar();
  },
  computed: {
    totalConDescuento() {
      return Math.max(0, this.totalPedido - this.descuento);
    },
    cambio() {
      return Math.max(0, this.efectivo + this.montoQR - this.totalConDescuento);
    },
    productosFiltrados() {
      let productos = this.productos;
      if (this.filtroProducto.trim() !== "") {
        const busqueda = this.filtroProducto.toLowerCase();
        productos = productos.filter(
          (p) =>
            p.descripcion.toLowerCase().includes(busqueda) ||
            (p.codigo_interno &&
              p.codigo_interno.toLowerCase().includes(busqueda)),
        );
      }
      const inicio = (this.currentPage - 1) * this.productosPorPagina;
      return productos.slice(inicio, inicio + this.productosPorPagina);
    },
    totalPaginas() {
      const total =
        this.filtroProducto.trim() !== ""
          ? this.productos.filter(
              (p) =>
                p.descripcion
                  .toLowerCase()
                  .includes(this.filtroProducto.toLowerCase()) ||
                (p.codigo_interno &&
                  p.codigo_interno
                    .toLowerCase()
                    .includes(this.filtroProducto.toLowerCase())),
            ).length
          : this.productos.length;
      return Math.ceil(total / this.productosPorPagina);
    },
    estadoPedidoTexto() {
      const estados = {
        1: "Nuevo",
        2: "En Cocina",
        3: "Listo",
        4: "Entregado",
        5: "Cerrado",
      };
      return this.pedido
        ? estados[this.pedido.estado] || "Desconocido"
        : "Nuevo";
    },
    estadoPedidoClass() {
      const clases = {
        1: "estado-nuevo",
        2: "estado-cocina",
        3: "estado-listo",
        4: "estado-entregado",
        5: "estado-cerrado",
      };
      return this.pedido ? clases[this.pedido.estado] || "" : "";
    },
    mesaEfectiva() {
      if (this.mesa) return this.mesa;
      if (this.mesaSeleccionadaId)
        return (
          this.mesasDisponibles.find((m) => m.id === this.mesaSeleccionadaId) ||
          null
        );
      return null;
    },
  },
  watch: {
    clienteSelect: {
      async handler(datos) {
        this.onClienteSelect(datos);
      },
      deep: true,
    },
    totalConDescuento(val) {
      if (this.aCredito) {
        this.efectivo = 0;
        this.montoQR = 0;
        return;
      }
      if (!this.pagoQR) {
        this.efectivo = val;
        this.montoQR = 0;
      } else {
        const suma = this.efectivo + this.montoQR;
        if (suma !== val) {
          this.montoQR = val;
          this.efectivo = 0;
        }
      }
    },
    pagoQR(val) {
      if (this.aCredito) return;
      if (val) {
        this.montoQR = this.totalConDescuento;
        this.efectivo = 0;
      } else {
        this.efectivo = this.totalConDescuento;
        this.montoQR = 0;
      }
    },
    observaciones() {
      this.guardarObservacionesGeneral();
    },
    efectivo(newVal) {
      if (this.aCredito) return;
      if (this.pagoQR && newVal > 0) {
        const suma = parseFloat(newVal) + parseFloat(this.montoQR);
        if (suma > this.totalConDescuento) {
          this.$nextTick(() => {
            this.efectivo = Math.max(0, this.totalConDescuento - this.montoQR);
          });
        }
      }
    },
    montoQR(newVal) {
      if (this.aCredito) return;
      if (this.pagoQR && newVal > 0) {
        const suma = parseFloat(this.efectivo) + parseFloat(newVal);
        if (suma > this.totalConDescuento) {
          this.$nextTick(() => {
            this.montoQR = Math.max(0, this.totalConDescuento - this.efectivo);
          });
        }
      }
    },
    categoriaActiva(val) {
      this.currentPage = 1;
      this.productos =
        val === null
          ? this.todosLosProductos
          : this.todosLosProductos.filter((p) => p.grupo_id === val);
    },
    filtroProducto() {
      this.currentPage = 1;
    },
  },
  methods: {
    abrirModalNuevoCliente() {
      this.cliente = {
        estado: { label: "Activo", value: 1 },
        nombre: this.clienteSelect?.nombre ?? this.clienteSelect,
        tipo_cliente: this.clienteSelect?.tipo_cliente ?? 0,
      };
      this.clienteModal = true;
    },
    async togglePagoQR() {
      if (this.aCredito) return;
      this.pagoQR = !this.pagoQR;
      if (this.pagoQR) {
        this.montoQR = this.totalConDescuento;
        this.efectivo = 0;
        if (!this.qr_url) {
          try {
            const response = await this.cajaService.getQrSucursal();
            this.qr_url = response.qr_url;
          } catch (e) {
            console.error(e);
          }
        }
      } else {
        this.efectivo = this.totalConDescuento;
        this.montoQR = 0;
      }
    },
    toggleFacturar() {
      this.facturar = !this.facturar;
    },
    toggleCredito() {
      if (this.esYango) return;
      this.aCredito = !this.aCredito;
      if (this.aCredito) {
        this.efectivo = 0;
        this.montoQR = 0;
        this.pagoQR = false;
      } else {
        this.efectivo = this.totalConDescuento;
        this.montoQR = 0;
      }
    },
    imprimirVenta(id) {
      if (this.imprimiendo) return;
      this.imprimiendo = true;
      this.ventaService.imprimirVenta(id).finally(() => {
        this.imprimiendo = false;
      });
    },
    imprimirDirecto(id) {
      if (this.imprimiendoDirecto) return;
      this.imprimiendoDirecto = true;
      this.ventaService
        .imprimirDirecto(id, this.printerName)
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error.message || "No se pudo imprimir ticket.",
            life: 4000,
          });
        })
        .finally(() => {
          this.imprimiendoDirecto = false;
        });
      if (this.imprimir_comanda) {
        const printer = this.comanda_impresora_separada
          ? this.printerCocina
          : this.printerName;
        setTimeout(() => {
          this.ventaService.imprimirComanda(id, printer).catch((e) => {
            console.warn("Error comanda:", e);
          });
        }, 800);
      }
    },
    imprimirComanda(id) {
      if (this.imprimiendoComanda) return;
      this.imprimiendoComanda = true;
      this.ventaService.imprimirVentaComandaPDF(id).finally(() => {
        this.imprimiendoComanda = false;
      });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("es-BO", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value || 0);
    },
    async inicializar() {
      try {
        await this.cargarCaja();
        if (!this.caja && !this.modo_venta_rapida) {
          this.cargandoComponente = true;
          return;
        }
        await this.cargarProductos();
        const pedidoId = this.$route.params.pedido_id;
        const mesaId = this.$route.params.mesa_id;
        if (pedidoId) {
          await this.cargarPedido(pedidoId);
        } else if (mesaId) {
          await this.cargarMesa(mesaId);
          await this.crearNuevoPedido(mesaId);
        } else if (this.esYango) {
          await this.recuperarOCrearYango();
        } else if (this.esParaLlevar) {
          await this.recuperarPedidoExistente("para_llevar");
        }
        if (this.asignar_mesa_manual) {
          await this.cargarPendientesMesa();
        }
        this.cargandoComponente = true;
      } catch (error) {
        console.error("Error init:", error);
        this.cargandoComponente = true;
      }
    },
    async recuperarPedidoExistente(tipo) {
      try {
        const response = await this.restauranteService.crearPedidoParaLlevar({
          cliente_id: this.clienteSelect?.id || 1,
          tipo,
          solo_buscar: true,
        });
        if (response.pedido) {
          this.pedido = response.pedido;
          this.items = response.pedido.items || [];
          if (response.pedido.cliente)
            this.clienteSelect = response.pedido.cliente;
          this.observaciones = response.pedido.nota_cliente || "";
          this.calcularTotal();
        }
      } catch (e) {
        console.error("Error recuperando pedido:", e);
      }
    },
    async aplicarCambioTipo(tipo) {
      this.pedido = null;
      this.items = [];
      this.mesa = null;
      this.observaciones = "";
      this.totalPedido = 0;
      this.efectivo = 0;
      this.montoQR = 0;
      this.aCredito = false;
      if (this.clienteDefecto) {
        this.clienteSelect = this.clienteDefecto;
        this.nit = this.clienteDefecto.ci_nit || "0";
        this.razon_social = this.clienteDefecto.nombre || "S/N";
      }
      if (tipo === "yango") {
        this.esYango = true;
        this.esParaLlevar = false;
        this.aCredito = true;
        await this.recuperarOCrearYango();
      } else if (tipo === "para_llevar") {
        this.esYango = false;
        this.esParaLlevar = true;
        await this.recuperarPedidoExistente("para_llevar");
      } else {
        this.esYango = false;
        this.esParaLlevar = false;
      }
    },
    async cambiarTipoServicio(tipo) {
      if (tipo === "yango" && this.esYango) return;
      if (tipo === "para_llevar" && this.esParaLlevar) return;
      if (tipo === "mesa" && !this.esParaLlevar && !this.esYango) return;
      if (this.pedido && this.items.length > 0) {
        this.$confirm.require({
          message: "Cambiar el tipo cancelará el pedido actual. ¿Continuar?",
          header: "Cambiar tipo de servicio",
          icon: "pi pi-exclamation-triangle",
          acceptClass: "p-button-info",
          acceptLabel: "SI, CONTINUAR",
          rejectLabel: "CANCELAR",
          rejectClass: "p-button-danger",
          rejectIcon: "pi pi-times",
          acceptIcon: "pi pi-check",
          defaultFocus: "reject",
          accept: async () => {
            await this.restauranteService.cancelarPedido(this.pedido.id);
            await this.aplicarCambioTipo(tipo);
          },
        });
        return;
      }
      if (this.pedido && this.items.length === 0) {
        try {
          await this.restauranteService.cancelarPedido(this.pedido.id);
        } catch (e) {
          console.warn("No se pudo cancelar pedido vacío:", e);
        }
      }
      await this.aplicarCambioTipo(tipo);
    },
    async cargarCaja() {
      try {
        const response = await this.cajaService.verificarCajaAbierta();
        this.caja =
          response && response.caja && response.caja.length > 0
            ? response.caja[0]
            : null;
        this.sucursal_id =
          response?.sucursal_id || this.caja?.sucursal_id || null;
        this.qr_url = response.qr_url || null;
        this.imprimir_directo = response.imprimir_directo || false;
        this.printerName = response.printerName || "";
        this.imprimir_comanda = response.imprimir_comanda || false;
        this.comanda_impresora_separada =
          response.comanda_impresora_separada || false;
        this.printerCocina = response.printerCocina || null;
        this.modo_venta_rapida = response.modo_venta_rapida || false;
        this.asignar_mesa_manual = response.asignar_mesa_manual || false;
        if (this.esYango && response.cliente_yango) {
          this.clienteSelect = response.cliente_yango;
          this.nit = response.cliente_yango.ci_nit || "0";
          this.razon_social = response.cliente_yango.nombre || "S/N";
        } else if (this.esYango && !response.cliente_yango) {
          await this.buscarYSeleccionarClienteYango();
        } else if (response.cliente_defecto) {
          this.clienteDefecto = response.cliente_defecto;
          this.clienteSelect = response.cliente_defecto;
          this.nit = response.cliente_defecto.ci_nit || "0";
          this.razon_social = response.cliente_defecto.nombre || "S/N";
        }
      } catch (error) {
        this.caja = null;
      }
    },
    async buscarYSeleccionarClienteYango() {
      try {
        const response = await this.clienteService.buscarXNombre({
          texto: "Yango",
          sucursal_id: this.caja?.sucursal_id,
        });
        const clientes = response.clientes || [];
        if (clientes.length > 0) {
          const exacto =
            clientes.find((cl) => cl.nombre?.toLowerCase().includes("yango")) ||
            clientes[0];
          this.clienteSelect = exacto;
          this.nit = exacto.ci_nit || "0";
          this.razon_social = exacto.nombre || "S/N";
        }
      } catch (e) {
        console.warn("No se pudo buscar cliente Yango:", e);
      }
    },
    async cargarProductos() {
      const sucursalId = this.caja?.sucursal_id || this.sucursal_id;
      if (!sucursalId) return;
      this.cargandoProductos = true;
      try {
        const response = await this.restauranteService.getProductosMenu({
          sucursal_id: sucursalId,
          page: 1,
          per_page: 9999,
        });
        if (response.status === 200) {
          this.todosLosProductos = response.productos;
          this.productos = response.productos;
          this.categorias = response.categorias || [];
          this.omitir_cocina = response.omitir_cocina;
          this.currentPage = 1;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.cargandoProductos = false;
      }
    },
    paginaSiguiente() {
      if (this.currentPage < this.totalPaginas) this.currentPage++;
    },
    paginaAnterior() {
      if (this.currentPage > 1) this.currentPage--;
    },
    async cargarMesa(mesaId) {
      const response = await this.restauranteService.getMesa(mesaId);
      this.mesa = response.mesa;
    },
    async cargarPedido(pedidoId) {
      const response = await this.restauranteService.getPedido(pedidoId);
      this.pedido = response.pedido;
      this.mesa = response.pedido.mesa || null;
      this.items = response.pedido.items || [];
      this.observaciones = response.pedido.nota_cliente || "";
      const tieneMesa = !!response.pedido.mesa_id;
      const tipoServicio = response.pedido.tipo_servicio;
      if (tieneMesa) {
        this.esParaLlevar = false;
        this.esYango = false;
      } else {
        this.esYango = tipoServicio === "yango";
        this.esParaLlevar = tipoServicio === "para_llevar";
      }
      if (response.pedido.cliente_id && response.pedido.cliente)
        this.clienteSelect = response.pedido.cliente;
      this.calcularTotal();
    },
    async crearNuevoPedido(mesaId) {
      try {
        const response = await this.restauranteService.crearPedido({
          mesa_id: mesaId,
          cliente_id: this.clienteSelect?.id || 1,
          tipo_servicio: "mesa",
          tipo: "para_mesa",
        });
        this.pedido = response.pedido;
        this.items = response.pedido.items || [];
        if (response.pedido.cliente)
          this.clienteSelect = response.pedido.cliente;
        this.observaciones = response.pedido.nota_cliente || "";
        this.calcularTotal();
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error al crear pedido",
          life: 3000,
        });
      }
    },
    async crearPedidoYango() {
      try {
        const response = await this.restauranteService.crearPedidoYango({
          cliente_id: this.clienteSelect?.id || 1,
        });
        if (response.pedido) {
          this.pedido = response.pedido;
          this.items = response.pedido.items || [];
          if (response.pedido.cliente)
            this.clienteSelect = response.pedido.cliente;
          this.observaciones = response.pedido.nota_cliente || "";
          this.calcularTotal();
        }
        this.aCredito = true;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error al crear pedido Yango",
          life: 3000,
        });
      }
    },
    async recuperarOCrearYango() {
      try {
        const response = await this.restauranteService.crearPedidoYango({
          cliente_id: this.clienteSelect?.id || 1,
          solo_buscar: true,
        });
        if (response.pedido) {
          this.pedido = response.pedido;
          this.items = response.pedido.items || [];
          this.observaciones = response.pedido.nota_cliente || "";
          this.calcularTotal();
          const clientePedido = response.pedido.cliente;
          const esClienteGenerico =
            !clientePedido ||
            clientePedido.nombre === "S/N" ||
            clientePedido.id === 1;
          if (!esClienteGenerico) {
            this.clienteSelect = clientePedido;
            this.nit = clientePedido.ci_nit || "0";
            this.razon_social = clientePedido.nombre || "S/N";
          } else {
            await this.buscarYSeleccionarClienteYango();
            if (
              this.clienteSelect?.id &&
              this.clienteSelect.id !== 1 &&
              this.pedido?.id
            ) {
              try {
                await this.restauranteService.actualizarClientePedido(
                  this.pedido.id,
                  this.clienteSelect.id,
                );
                this.pedido.cliente_id = this.clienteSelect.id;
              } catch (e) {
                console.warn(
                  "No se pudo actualizar cliente en pedido Yango:",
                  e,
                );
              }
            }
          }
        } else {
          await this.buscarYSeleccionarClienteYango();
          await this.crearPedidoYango();
        }
        this.aCredito = true;
      } catch (e) {
        console.error("Error recuperando Yango:", e);
        this.aCredito = true;
      }
    },
    async crearPedidoParaLlevar() {
      try {
        const response = await this.restauranteService.crearPedidoParaLlevar({
          cliente_id: this.clienteSelect?.id || 1,
        });
        if (response.pedido) {
          this.pedido = response.pedido;
          this.items = response.pedido.items || [];
          this.mesa = null;
          if (response.pedido.cliente)
            this.clienteSelect = response.pedido.cliente;
          this.observaciones = response.pedido.nota_cliente || "";
          this.calcularTotal();
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error al crear pedido",
          life: 3000,
        });
      }
    },
    async asegurarPedido() {
      if (this.pedido) return;
      if (this.esYango) {
        await this.crearPedidoYango();
      } else if (this.esParaLlevar) {
        await this.crearPedidoParaLlevar();
      } else {
        await this.crearPedidoMesaRapido();
      }
    },
    async crearPedidoMesaRapido() {
      try {
        const response = await this.restauranteService.crearPedidoParaLlevar({
          cliente_id: this.clienteSelect?.id || 1,
          tipo: "para_mesa",
        });
        this.pedido = response.pedido;
        this.items = response.pedido.items || [];
        this.mesa = null;
        if (response.pedido.cliente)
          this.clienteSelect = response.pedido.cliente;
        this.observaciones = response.pedido.nota_cliente || "";
        this.calcularTotal();
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error al crear pedido",
          life: 3000,
        });
      }
    },
    async cargarMesasDisponibles() {
      try {
        const response = await this.restauranteService.getMesas();
        this.mesasDisponibles = (response.data || []).filter(
          (m) => m.estado === 1,
        );
      } catch (e) {
        console.error(e);
      }
    },
    async cargarPendientesMesa() {
      try {
        const response = await this.restauranteService.getPendientesMesa();
        this.ventasPendientesMesa = response.pedidos || [];
      } catch (e) {
        console.error(e);
      }
    },
    abrirAsignarMesa(pedido) {
      this.pedidoPendienteSel = pedido;
      this.mesaParaAsignar = null;
      if (this.mesasDisponibles.length === 0) this.cargarMesasDisponibles();
      this.modalAsignarMesa = true;
    },
    async confirmarAsignarMesa() {
      if (!this.mesaParaAsignar || !this.pedidoPendienteSel) return;
      this.asignandoMesa = true;
      try {
        await this.restauranteService.asignarMesaPedido(
          this.pedidoPendienteSel.id,
          this.mesaParaAsignar,
        );
        this.$toast.add({
          severity: "success",
          summary: "Mesa asignada",
          detail: `Pedido #${this.pedidoPendienteSel.nro_pedido} asignado`,
          life: 2000,
        });
        this.modalAsignarMesa = false;
        this.pedidoPendienteSel = null;
        await this.cargarPendientesMesa();
      } catch (e) {
        this.$toast.add({
          severity: "error",
          summary: "Error al asignar mesa",
          life: 2000,
        });
      } finally {
        this.asignandoMesa = false;
      }
    },
    async agregarOIncrementar(producto) {
      if (!producto || !producto.id) return;
      if (!this.pedido) await this.asegurarPedido();
      const itemExistente = this.items.find(
        (item) => item.producto_id === producto.id,
      );
      if (itemExistente) {
        await this.cambiarCantidad(itemExistente, 1);
        this.$toast.add({
          severity: "info",
          summary: "Agregado",
          detail: `+1 ${producto.descripcion}`,
          life: 1000,
        });
      } else {
        try {
          const response = await this.restauranteService.agregarItemPedido(
            this.pedido.id,
            { producto_id: producto.id, cantidad: 1 },
          );
          this.items = response.pedido.items || [];
          this.calcularTotal();
          this.$toast.add({
            severity: "success",
            summary: "Nuevo Item",
            detail: producto.descripcion,
            life: 1000,
          });
        } catch (error) {
          this.$toast.add({
            severity: "error",
            summary: "Error al agregar",
            life: 2000,
          });
        }
      }
    },
    async onClienteSelect(datos) {
      if (!datos || typeof datos !== "object" || !datos.id) return;
      this.nit = datos.ci_nit || "0";
      this.razon_social = datos.nombre || "S/N";
      if (
        this.pedido &&
        this.pedido.id &&
        this.pedido.cliente_id !== datos.id
      ) {
        try {
          await this.restauranteService.actualizarClientePedido(
            this.pedido.id,
            datos.id,
          );
          this.pedido.cliente_id = datos.id;
        } catch (error) {
          console.error(error);
        }
      }
    },
    buscarCliente(event) {
      const query = event.query.trim();
      if (!query) {
        this.clientes = [];
        return;
      }
      this.buscarClienteImpl(query);
    },
    async buscarClienteImpl(texto) {
      this.cargandoClientes = true;
      try {
        const response = await this.clienteService.buscarXNombre({
          texto,
          sucursal_id: this.caja?.sucursal_id || null,
        });
        this.clientes = response.clientes || [];
      } catch (error) {
        this.clientes = [];
      } finally {
        this.cargandoClientes = false;
      }
    },
    async buscarYAsignarCliente(clienteCreado) {
      if (clienteCreado && clienteCreado.id) {
        this.clienteSelect = clienteCreado;
        this.nit = clienteCreado.ci_nit || "0";
        this.razon_social = clienteCreado.nombre || "S/N";
        if (this.pedido && this.pedido.id) {
          try {
            await this.restauranteService.actualizarClientePedido(
              this.pedido.id,
              clienteCreado.id,
            );
            this.pedido.cliente_id = clienteCreado.id;
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        const nombreBuscar = this.cliente?.nombre || this.clienteSelect;
        if (nombreBuscar) {
          await this.buscarClienteImpl(nombreBuscar);
          if (this.clientes && this.clientes.length > 0) {
            this.clienteSelect = this.clientes[0];
            this.nit = this.clientes[0].ci_nit || "0";
            this.razon_social = this.clientes[0].nombre || "S/N";
            if (this.pedido && this.pedido.id) {
              try {
                await this.restauranteService.actualizarClientePedido(
                  this.pedido.id,
                  this.clientes[0].id,
                );
                this.pedido.cliente_id = this.clientes[0].id;
              } catch (error) {
                console.error(error);
              }
            }
          }
        }
      }
    },
    cerrarModalCliente() {
      this.clienteModal = false;
    },
    async cambiarCantidad(item, delta) {
      this.cargandoItems = true;
      const nuevaCantidad = item.cantidad + delta;
      try {
        if (delta > 0) {
          await this.restauranteService.agregarItemPedido(this.pedido.id, {
            producto_id: item.producto_id,
            cantidad: 1,
          });
        } else {
          item.cantidad = nuevaCantidad;
        }
        item.cantidad = nuevaCantidad;
        this.calcularTotal();
      } catch (e) {
        console.error(e);
      } finally {
        this.cargandoItems = false;
      }
    },
    confirmarEliminarItem(item) {
      this.$confirm.require({
        message: `¿Quitar ${item.producto.descripcion} del pedido?`,
        header: "Quitar producto",
        icon: "pi pi-exclamation-circle",
        acceptClass: "p-button-danger",
        accept: () => this.eliminarItem(item),
      });
    },
    async eliminarItem(item) {
      try {
        const response = await this.restauranteService.eliminarItemPedido(
          item.id,
        );
        this.items = response.pedido.items || [];
        this.calcularTotal();
        this.$toast.add({
          severity: "success",
          summary: "Eliminado",
          life: 1000,
        });
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "No se pudo eliminar",
          life: 2000,
        });
      }
    },
    calcularSubtotal(item) {
      return (item.precio_unitario || 0) * (item.cantidad || 0);
    },
    calcularTotal() {
      this.totalPedido = this.items.reduce(
        (sum, item) => sum + this.calcularSubtotal(item),
        0,
      );
      if (!this.aCredito && this.efectivo < this.totalConDescuento)
        this.efectivo = this.totalConDescuento;
    },
    abrirModalNotaItem(item) {
      this.itemEditandoNota = item;
      this.notaItemTemporal = item.nota_cocina || "";
      this.notaItemModal = true;
    },
    async guardarNotaItemModal() {
      if (!this.itemEditandoNota) return;
      try {
        await this.restauranteService.actualizarNotaItem(
          this.itemEditandoNota.id,
          this.notaItemTemporal,
        );
        this.itemEditandoNota.nota_cocina = this.notaItemTemporal;
        this.$toast.add({
          severity: "success",
          summary: "Nota guardada",
          life: 1500,
        });
        this.cerrarModalNotaItem();
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error al guardar nota",
          life: 2000,
        });
      }
    },
    cerrarModalNotaItem() {
      this.notaItemModal = false;
      this.itemEditandoNota = null;
      this.notaItemTemporal = "";
    },
    guardarObservacionesGeneral() {
      if (this.timeoutNotaGeneral) clearTimeout(this.timeoutNotaGeneral);
      this.timeoutNotaGeneral = setTimeout(async () => {
        await this.guardarObservacionesGeneralImpl();
      }, 1000);
    },
    async guardarObservacionesGeneralImpl() {
      if (!this.pedido || !this.pedido.id) return;
      this.guardandoNotaGeneral = true;
      this.notaGeneralGuardada = false;
      try {
        await this.restauranteService.actualizarObservacionesPedido(
          this.pedido.id,
          this.observaciones,
        );
        this.notaGeneralGuardada = true;
        setTimeout(() => {
          this.notaGeneralGuardada = false;
        }, 2000);
      } catch (error) {
        console.error("Error al guardar observaciones:", error);
      } finally {
        this.guardandoNotaGeneral = false;
      }
    },
    async cobrarPedido() {
      if (this.guardando) return;
      this.guardando = true;
      try {
        const nroPedidoActual = this.pedido.nro_pedido;
        const response = await this.restauranteService.getPedido(
          this.pedido.id,
        );
        this.pedido = response.pedido;
        if (!this.pedido.nro_pedido) this.pedido.nro_pedido = nroPedidoActual;
        this.items = response.pedido.items || [];
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "No se pudo verificar el pedido",
          life: 3000,
        });
        return;
      } finally {
        this.guardando = false;
      }
      if (this.pedido.venta_id) {
        this.$toast.add({
          severity: "warn",
          summary: "Ya cobrado",
          detail: "Este pedido ya tiene una venta registrada",
          life: 3000,
        });
        return;
      }
      let clienteId = null;
      if (
        this.clienteSelect &&
        typeof this.clienteSelect === "object" &&
        this.clienteSelect.id
      ) {
        clienteId = this.clienteSelect.id;
      } else if (this.clienteSelect && typeof this.clienteSelect === "string") {
        await this.buscarClienteImpl(this.clienteSelect);
        if (this.clientes?.length > 0) {
          this.clienteSelect = this.clientes[0];
          clienteId = this.clientes[0].id;
        }
      } else if (this.pedido.cliente_id) {
        clienteId = this.pedido.cliente_id;
      }
      if (!clienteId) {
        this.$toast.add({
          severity: "warn",
          summary: "Falta Cliente",
          detail: "Selecciona un cliente",
          life: 3000,
        });
        return;
      }
      const totalPagado = parseFloat(this.efectivo) + parseFloat(this.montoQR);
      if (!this.aCredito && totalPagado < this.totalConDescuento) {
        this.$toast.add({
          severity: "error",
          summary: "Monto insuficiente",
          detail: `Falta: Bs. ${this.formatCurrency(
            this.totalConDescuento - totalPagado,
          )}`,
          life: 3000,
        });
        return;
      }
      if (!this.aCredito && totalPagado > this.totalConDescuento + 0.01) {
        this.$toast.add({
          severity: "warn",
          summary: "Monto excedido",
          detail: "El pago no puede superar el total",
          life: 3000,
        });
        return;
      }
      this.mesaSeleccionadaId = null;
      this.nroOrdenYango = "";
      if (!this.esParaLlevar && !this.esYango && !this.mesa) {
        await this.cargarMesasDisponibles();
      }
      this.modalConfirmarCobro = true;
    },
    async procesarCobro(liberarMesa = false) {
      if (this.esYango && !this.nroOrdenYango.trim()) {
        this.$toast.add({
          severity: "warn",
          summary: "Falta N° Orden Yango",
          detail: "El número de orden es obligatorio",
          life: 3000,
        });
        return;
      }
      if (liberarMesa) {
        this.guardandoLiberar = true;
      } else {
        this.guardando = true;
      }
      this.liberarMesaAutomatico = liberarMesa;
      try {
        let clienteId = null;
        if (
          this.clienteSelect &&
          typeof this.clienteSelect === "object" &&
          this.clienteSelect.id
        ) {
          clienteId = this.clienteSelect.id;
        } else if (this.pedido && this.pedido.cliente_id) {
          clienteId = this.pedido.cliente_id;
        }
        if (!clienteId) {
          this.$toast.add({
            severity: "warn",
            summary: "Error",
            detail: "No se pudo identificar el cliente",
            life: 3000,
          });
          this.guardando = false;
          this.guardandoLiberar = false;
          return;
        }
        const datos = {
          cliente_id: clienteId,
          caja_id: this.caja?.id || null,
          metodo_pago_id: this.esYango ? 1 : this.pagoQR ? 6 : 1,
          tipo_pago_id: this.aCredito ? 2 : 1,
          efectivo: this.aCredito ? 0 : this.efectivo,
          monto_pago: this.aCredito ? 0 : this.montoQR,
          descuento: this.descuento,
          facturado: this.facturar ? 1 : 0,
          nit: this.facturar ? this.nit : null,
          razon_social: this.facturar ? this.razon_social : "S/N",
          observaciones: this.observaciones,
          a_credito: this.aCredito ? 1 : 0,
          liberar_mesa: liberarMesa ? 1 : 0,
          numero_pedido_yango: this.esYango ? this.nroOrdenYango.trim() : null,
        };
        let response;
        if (this.esYango) {
          response = await this.restauranteService.cobrarPedidoYango(
            this.pedido.id,
            datos,
          );
        } else if (this.esParaLlevar || !this.mesa) {
          response = await this.restauranteService.cobrarPedidoParaLlevar(
            this.pedido.id,
            { ...datos, mesa_id: this.mesaSeleccionadaId || null },
          );
        } else {
          response = await this.restauranteService.cerrarMesa(
            this.mesa.id,
            datos,
          );
        }
        if (response.status === 200) {
          const ventaId = response.venta?.id;
          this.ultimaVentaId = ventaId || null;
          if (ventaId && this.imprimir_directo) {
            if (this.printerName) {
              setTimeout(() => {
                this.imprimirDirecto(ventaId);
              });
            } else {
              setTimeout(() => {
                this.imprimirVenta(ventaId);
              }, 500);
            }
          }
          if (ventaId && this.imprimir_comanda) {
            const printer = this.comanda_impresora_separada
              ? this.printerCocina
              : this.printerName;
            setTimeout(() => {
              this.ventaService.imprimirComanda(ventaId, printer).catch((e) => {
                console.warn("Error comanda:", e);
              });
            }, 800);
          }
          this.$toast.add({
            severity: "success",
            summary: "Venta Exitosa",
            detail: this.esYango
              ? `Yango #${this.nroOrdenYango} cobrado`
              : this.esParaLlevar
              ? "Pedido cobrado"
              : "Mesa cobrada",
            life: 2000,
          });
          this.items = [];
          this.totalPedido = 0;
          this.efectivo = 0;
          this.montoQR = 0;
          this.descuento = 0;
          this.observaciones = "";
          this.pedido = null;
          setTimeout(() => {
            this.$router.replace({ name: "restaurante_plano_mesas" });
          }, 1000);
        } else {
          this.$toast.add({
            severity: "warn",
            summary: "Atención",
            detail:
              response.data?.mensaje ||
              response.mensaje ||
              "Error al procesar el cobro",
            life: 4000,
          });
        }
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail:
            error.response?.data?.mensaje || "Error crítico al procesar venta",
          life: 3000,
        });
      } finally {
        this.guardando = false;
        this.guardandoLiberar = false;
        this.modalConfirmarCobro = false;
      }
    },
    confirmarCancelarPedido() {
      this.$confirm.require({
        message:
          "Esta acción anulará el pedido completo y liberará la mesa. ¿Continuar?",
        header: "Anular Pedido",
        icon: "pi pi-exclamation-triangle",
        acceptClass: "p-button-danger",
        accept: () => this.cancelarPedido(),
      });
    },
    async cancelarPedido() {
      try {
        await this.restauranteService.cancelarPedido(this.pedido.id);
        this.$toast.add({
          severity: "success",
          summary: "Cancelado",
          life: 1500,
        });
        this.$router.replace({ name: "restaurante_plano_mesas" });
      } catch (error) {
        this.$toast.add({ severity: "error", summary: "Error", life: 2000 });
      }
    },
  },
  unmounted() {
    if (this.timeoutNotaGeneral) clearTimeout(this.timeoutNotaGeneral);
  },
};
</script>

<style scoped>
.productos-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding-bottom: 8px;
}
.prod-card {
  background: #fafbfc;
  border-radius: 14px;
  border: 1.5px solid #d1d5db;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1),
    box-shadow 0.22s ease, border-color 0.15s;
  user-select: none;
  transform-origin: left center;
}
.prod-card:hover {
  transform: scale(1.06);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.15);
  border-color: #94a3b8;
  z-index: 3;
  background: #fff;
}
.prod-card:active {
  transform: scale(0.97);
  transition-duration: 0.08s;
}
.prod-agotado {
  opacity: 0.5;
  filter: grayscale(70%);
}
.prod-img-wrap {
  width: 100%;
  padding-top: 65%;
  position: relative;
  background: #f8fafc;
}
.prod-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.prod-img-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
}
.prod-body {
  padding: 10px 10px 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
}
.prod-nombre {
  font-size: 1rem !important;
  font-weight: 800;
  color: #1e293b;
  line-height: 1.25;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}
.prod-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
}
.prod-precio {
  font-size: 1.2rem !important;
  font-weight: 900;
  color: #1e293b;
  line-height: 1;
}
.prod-bs {
  font-size: 0.7rem;
  font-weight: 400;
  color: #94a3b8;
  margin-right: 2px;
}
.btn-mas {
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;
}
.btn-mas-act {
  background: linear-gradient(135deg, #f97316, #ea580c);
  color: #fff;
  box-shadow: 0 3px 10px rgba(234, 88, 12, 0.45);
}
.btn-mas-act:hover {
  background: linear-gradient(135deg, #fb923c, #f97316);
  transform: scale(1.18);
  box-shadow: 0 5px 16px rgba(234, 88, 12, 0.55);
}
.btn-mas-act:active {
  transform: scale(0.9);
}
.btn-mas-dis {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
}
.badge-stock {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
  background: #fff7ed;
  color: #c2410c;
  font-size: 0.6rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 20px;
  border: 1px solid #fed7aa;
}
.badge-agotado-tag {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 0.6rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 20px;
}
.sin-resultados {
  grid-column: 1 / -1;
  text-align: center;
  padding: 3rem;
}
@media screen and (max-width: 991px) {
  .productos-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid.app-background,
  .grid.app-background > div {
    height: auto !important;
    overflow: visible !important;
    width: 100% !important;
  }
  .area-productos {
    height: auto !important;
    overflow: visible !important;
  }
  .cat-btn {
    font-size: 0.75rem !important;
  }
  .buscador-input {
    height: 2.8rem !important;
    font-size: 0.95rem !important;
    border-width: 2.5px !important;
  }
  .buscador-icono {
    font-size: 1.1rem !important;
  }
  .btn-tipo {
    padding: 0 10px !important;
    font-size: 0.78rem !important;
  }
  .btn-tipo .btn-tipo-texto {
    display: none;
  }
}
.app-background {
  background-color: #ffffff;
}
.text-slate-800 {
  color: #1e293b;
}
.bg-slate-800 {
  background-color: #1e293b;
}
.btn-gradiente-orange {
  background: linear-gradient(135deg, #3a4659 0%, #1e293b 100%);
  border: none;
}
.btn-gradiente-orange:hover {
  background: linear-gradient(135deg, #3a4659 0%, #1e293b 100%);
  transform: translateY(-1px);
}
.custom-scroll::-webkit-scrollbar,
.scroll-oculto::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 10px;
}
.glass-header {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.buscador-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.buscador-icono {
  position: absolute;
  left: 12px;
  color: #1e293b;
  font-size: 0.95rem;
  pointer-events: none;
  z-index: 1;
  font-weight: 900;
}
.buscador-input {
  width: 100%;
  height: 2.5rem;
  padding-left: 2.2rem !important;
  border-radius: 10px !important;
  border: 2px solid #cbd5e1 !important;
  background: #f8fafc !important;
  font-weight: 600;
  font-size: 0.88rem;
  color: #1e293b;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.buscador-input:focus {
  border-color: #1e293b !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(30, 41, 59, 0.08) !important;
  outline: none;
}
.buscador-input::placeholder {
  color: #94a3b8;
  font-weight: 500;
}
.btn-tipo {
  height: 2.5rem;
  padding: 0 14px;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.82rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.btn-tipo-activo {
  background: #1e293b;
  color: white;
  box-shadow: 0 2px 8px rgba(30, 41, 59, 0.3);
}
.btn-tipo-llevar {
  background: #f97316;
  color: white;
  box-shadow: 0 2px 8px rgba(249, 115, 22, 0.3);
}
.btn-tipo-yango {
  background: #ef4444;
  color: white;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}
.btn-tipo-inactivo {
  background: #f1f5f9;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
}
.btn-tipo-inactivo:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.cat-btn {
  height: 1.9rem;
  font-size: 0.8rem;
  line-height: 1;
}
.total-label {
  font-weight: 800;
  color: #1e293b;
  font-size: 1.2rem !important;
}
.total-monto {
  font-weight: 900;
  color: #1e3a8a;
  font-size: 1.6rem !important;
}
.shadow-top-large {
  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.05);
}
.badge-estado-pedido-inline {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0.2rem 0.6rem;
  border-radius: 10px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}
.estado-nuevo {
  background: #e0f2fe;
  color: #0369a1;
}
.estado-cocina {
  background: #fef3c7;
  color: #b45309;
}
.estado-listo {
  background: #dcfce7;
  color: #16a34a;
}
.estado-entregado {
  background: #f3f4f6;
  color: #6b7280;
}
.estado-cerrado {
  background: #f3f4f6;
  color: #6b7280;
}
.area-productos {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
.modal-cobro-compacto :deep(.p-dialog-content) {
  padding: 1rem;
  overflow: visible;
}
.modal-cobro-compacto :deep(.p-dialog-footer) {
  padding: 0.75rem 1rem;
  border-top: 1px solid #e5e7eb;
}
.confirmacion-cobro-compacta {
  font-size: 0.9rem;
}
.cat-scroll {
  scrollbar-width: thin;
  scrollbar-color: #1e293b #e5e7eb;
}
.cat-scroll::-webkit-scrollbar {
  height: 4px;
}
.cat-scroll::-webkit-scrollbar-track {
  background: #e5e7eb;
  border-radius: 4px;
}
.cat-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #1e293b 0%, #1e293b 100%);
  border-radius: 4px;
}
.loading-dot {
  opacity: 0.6;
  animation: dot-blink 1.2s ease-in-out infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes dot-blink {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
.carrito-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.cr-header {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
  flex-shrink: 0;
}
.cr-h-nombre {
  flex: 1;
  font-size: 0.7rem;
  font-weight: 800;
  color: #64748b;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.cr-h-cant {
  width: 80px;
  text-align: center;
  font-size: 0.7rem;
  font-weight: 800;
  color: #64748b;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.cr-h-total {
  width: 70px;
  text-align: right;
  font-size: 0.7rem;
  font-weight: 800;
  color: #64748b;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.carrito-lista {
  overflow-y: auto;
  height: calc(5 * 46px);
  background: #fff;
}
.carrito-vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  color: #cbd5e1;
  font-size: 0.85rem;
}
.carrito-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  height: 46px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.1s;
}
.carrito-row:hover {
  background: #f8fafc;
}
.carrito-row:last-child {
  border-bottom: none;
}
.cr-nombre-bloque {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.cr-nombre {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}
.cr-nota {
  font-size: 0.68rem;
  color: #ea580c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 2px;
}
.cr-cantidad {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
}
.cr-btn-qty {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.12s, transform 0.1s;
  background: #e2e8f0;
  color: #475569;
}
.cr-btn-qty:hover {
  transform: scale(1.15);
}
.cr-btn-minus:hover {
  background: #fecaca;
  color: #dc2626;
}
.cr-btn-plus:hover {
  background: #bbf7d0;
  color: #16a34a;
}
.cr-qty-num {
  font-size: 1rem;
  font-weight: 800;
  color: #1e293b;
  min-width: 20px;
  text-align: center;
}
.cr-total-bloque {
  width: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}
.cr-total {
  font-size: 1rem;
  font-weight: 800;
  color: #1e293b;
  white-space: nowrap;
}
.cr-btn-nota {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: none;
  background: #f1f5f9;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.12s;
}
.cr-btn-nota:hover {
  background: #fef3c7;
  color: #b45309;
}
.cr-btn-nota-activa {
  background: #fff7ed;
  color: #ea580c;
}
.chip-pendiente {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #fff7ed;
  border: 1.5px solid #fed7aa;
  color: #c2410c;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  flex-shrink: 0;
}
.chip-pendiente:hover {
  background: #ffedd5;
  border-color: #f97316;
  transform: translateY(-1px);
}
.chip-sep {
  color: #fba96a;
  font-weight: 400;
}
.pendientes-scroll::-webkit-scrollbar {
  height: 3px;
}
.pendientes-scroll::-webkit-scrollbar-thumb {
  background: #fed7aa;
  border-radius: 4px;
}
@media screen and (min-width: 992px) {
  .lg\:col-2-4 {
    width: 20% !important;
  }
}
@media screen and (min-width: 1200px) {
  .lg\:col-2-4 {
    width: 16.666% !important;
  }
}
</style>
